export const reviewsData = {
  average: 4.8,
  total: 250,
  per_page: 4,
  reviews: [
    {
      id: 1,
      name: "John Smith",
      role: "Student",
      rating: 5,
      title: "Excellent Experience",
      message:
        "Excellent traffic school! The course was easy to follow and the staff was very helpful. I would highly recommend Metro Traffic School to anyone.",
      review_date: "11/15/2025",
      avatar_url: null,
    },
    {
      id: 2,
      name: "Maria Garcia",
      role: "Student",
      rating: 4.5,
      title: "Great Service",
      message:
        "Great experience! The online course was convenient and well-organized. Customer service was responsive when I had questions.",
      review_date: "11/14/2025",
      avatar_url: null,
    },
    {
      id: 3,
      name: "David Johnson",
      role: "Student",
      rating: 5,
      title: "Best Traffic School",
      message:
        "Best traffic school in Florida! The instructors were knowledgeable and the material was presented clearly. Highly satisfied!",
      review_date: "11/13/2025",
      avatar_url: null,
    },
    {
      id: 4,
      name: "Sarah Williams",
      role: "Student",
      rating: 4,
      title: "Good Course",
      message:
        "Good course overall. Easy to navigate and complete at my own pace. Would recommend to friends and family.",
      review_date: "11/12/2025",
      avatar_url: null,
    },
    {
      id: 5,
      name: "Michael Brown",
      role: "Student",
      rating: 5,
      title: "Amazing Service",
      message:
        "Amazing service! The live chat support was incredibly helpful and the course content was engaging. Thank you Metro Traffic School!",
      review_date: "11/11/2025",
      avatar_url: null,
    },
    {
      id: 6,
      name: "Jennifer Martinez",
      role: "Student",
      rating: 4.5,
      title: "Very Professional",
      message:
        "Very professional and easy to use. Completed my course in no time. Great experience from start to finish!",
      review_date: "11/10/2025",
      avatar_url: null,
    },
    {
      id: 7,
      name: "Robert Davis",
      role: "Student",
      rating: 5,
      title: "Outstanding Course",
      message:
        "Outstanding! The course was informative and the customer support team went above and beyond. Definitely the best choice in Florida.",
      review_date: "11/09/2025",
      avatar_url: null,
    },
    {
      id: 8,
      name: "Lisa Anderson",
      role: "Student",
      rating: 4.5,
      title: "Super Convenient",
      message:
        "Super convenient online platform. The course was well structured and easy to understand. Highly recommend for busy schedules.",
      review_date: "11/08/2025",
      avatar_url: null,
    },
    {
      id: 9,
      name: "James Wilson",
      role: "Student",
      rating: 5,
      title: "Fantastic Experience",
      message:
        "Fantastic experience from start to finish. The material was engaging and the support staff was always available to help.",
      review_date: "11/07/2025",
      avatar_url: null,
    },
    {
      id: 10,
      name: "Patricia Taylor",
      role: "Student",
      rating: 4,
      title: "Great Traffic School",
      message:
        "Great traffic school! The lessons were clear and concise. Finished the course faster than expected. Very satisfied.",
      review_date: "11/06/2025",
      avatar_url: null,
    },
    {
      id: 11,
      name: "Christopher Lee",
      role: "Student",
      rating: 5,
      title: "Excellent Service",
      message:
        "Excellent service! The online course was user-friendly and the customer support was top-notch. Will recommend to everyone.",
      review_date: "11/05/2025",
      avatar_url: null,
    },
    {
      id: 12,
      name: "Emily Rodriguez",
      role: "Student",
      rating: 4.5,
      title: "Very Pleased",
      message:
        "Very pleased with Metro Traffic School. The course content was relevant and the interface was easy to navigate. Great job!",
      review_date: "11/04/2025",
      avatar_url: null,
    },
  ],
};
